import _ from 'lodash';
import * as yup from 'yup';

const fieldWhenM = (type, label) => {
  let schema;

  // 타입별 기초 스키마 설정
  switch (type) {
    case 'date':
      schema = yup.date().typeError('올바른 날짜 형식을 입력해주세요.');
      break;
    case 'select':
      schema = yup.string().ensure();
    case 'string':
      schema = yup.string().ensure();
      break;
    case 'number':
      schema = yup.number().typeError('숫자만 입력 가능합니다.').transform((v) => (isNaN(v) ? undefined : v));
      break;
    default:
      schema = yup.string().ensure();
  }

  // 공통 조건(M일 때 필수) 적용
  return schema.when('$prjTyp', {
    is: 'M',
    then: (s) => s.required(`${label} 선택하세요.`),
    otherwise: (s) => s.nullable().notRequired(),
  });
};

export const validationForecast = () => yup.object({
    prjTyp: yup.string().ensure().required('매출 타입을 선택하세요'),
    prjImpt: yup.string().ensure().required('프로젝트 중요도를 선택하세요'),
    bugetYn: yup.string().ensure().required('예산여부를 선택하세요'),
    cstNm: yup.string().ensure().required('사업명을 입력하세요'),
    productYn: yup.string().ensure().required('제품여부를 선택하세요'),
    expDay: yup.date().typeError('매출 예상일을 선택하세요.').required('매출 예상일을 선택하세요.'),
    clientCmpNm: yup.string().ensure().required('고객사를 선택하세요'),
    customerCf: yup.string().ensure().required('고객 구분을 선택하세요'),
    vendorCmpNm: yup.string().ensure().required('매출처를 선택하세요'),
    partnerTyp: yup.string().ensure().required('매출처 유형을 선택하세요'),
    salesTyp: yup.string().ensure().required('영업유형을 선택하세요'),
    crtNm: yup.string().ensure().required('영업담당자를 선택하세요'),
    invoiceToBe: yup.object({
    // 날짜 (Date)
        contractStDt: fieldWhenM('date', '계약 시작일을'),
        contractEdDt: fieldWhenM('date', '계약 종료일을'),
        invTo: fieldWhenM('select', '계산서 발행 예정일을'),
        colTo: fieldWhenM('select', '수금 예정일을'),
    }),
    costCalcs: yup.array().of(
        yup.object().shape({
        sellPartnerNm: yup.string().ensure().required('매입처를 선택하세요'),
        expCnt: yup
            .number()
            // .min(1, '최소 1 이상을 입력하세요')
            .required('수량을 입력하세요'),
        unitVal: yup.number().required('매출단가(VAT별도)를 입력하세요'),
        
        priceVal: yup.number().required('매입단가를 입력하세요'),
        }),
    ),
});